export interface LocaleRequestGeneration {
  current: number;
}

interface LatestLocaleRequestOptions<T> {
  generation: LocaleRequestGeneration;
  locale: T;
  load: (locale: T) => Promise<unknown>;
  onError: (locale: T, error: unknown) => void;
  onSuccess: (locale: T) => void;
}

export async function runLatestLocaleRequest<T>({
  generation,
  locale,
  load,
  onError,
  onSuccess
}: LatestLocaleRequestOptions<T>): Promise<void> {
  const requestGeneration = ++generation.current;
  try {
    await load(locale);
  } catch (error) {
    if (requestGeneration === generation.current) onError(locale, error);
    return;
  }
  if (requestGeneration === generation.current) onSuccess(locale);
}
